export default __webpack_public_path__ + "static/media/Beard_6_C3.1fd05bc6.svg";